import moment from 'moment';
import { language } from '../members/options';
import { gender, phonetype, relationship } from './options';

const findLabelByValue = (source, value) => source.find((g) => g.value === value)?.label;

export const genderFormatter = (value) => findLabelByValue(gender, value) || 'Unknown';

export const languageFormatter = (value) => findLabelByValue(language, value) || value;

export const genericFormatter = (value, options) => findLabelByValue(options || [], value) || value;

export const phoneAndEmailTypeFormatter = (value) => findLabelByValue(phonetype, value) || value;

export const relationshipFormatter = (value) =>
  findLabelByValue(relationship, value) || (value === 'RELATIONTYPE_UNK' ? 'Unknown' : value);

export const dateFormatter = (value) => (value ? moment.utc(value).format('MM/DD/YYYY') : value);
